import axiosInstance from "./axios.instance";

const API_FB_CREATE_APP = async (companyId) => {
  try {
    const resp = await axiosInstance.post(`/admin/company/${companyId}/create-gupshup-app`);
    return resp.data;
  } catch (error) {
    throw error;
  }
};
const API_FB_APP_STATUS = async (companyId) => {
  try {
    const resp = await axiosInstance.post(`/admin/company/${companyId}/check-fb-status`);
    return resp.data;
  } catch (error) {
    throw error;
  }
};
export {
    API_FB_CREATE_APP,
    API_FB_APP_STATUS
}